import { EventEmitter, Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';

declare const Kakao: any;

@Injectable({
  providedIn: 'root'
})
export class KakaoMapService {
  // private kakaoAppKey = environment.loginSocial.kakao.key; // Replace with your Kakao JavaScript key
  private kakaoAppKey = "5fc50299fcc0f2142faa37a79e38441f"; // Replace with your Kakao JavaScript key
  private kakaoApiKey = '35e6555060b4da7ee4aeb6a02db983b3';
  private polyline: any = null;
  private map: any;
  geocoder: any;
  public markerClicked: EventEmitter<any> = new EventEmitter<any>();
  public dragMaker: EventEmitter<any> = new EventEmitter<any>();
  constructor(private authService: AuthenticationService) {
    // this.kakaoAppKey = this.authService.getKakaoKey();
  }

  // Initialize Kakao SDK with your JavaScript key
  private initializeKakao(): void {
    if (Kakao && !Kakao.isInitialized()) {
      Kakao.init(this.kakaoAppKey);
      console.log('Kakao SDK initialized');
    }
  }

  removeOldKakaoScript() {
    const existingScript = document.getElementById("kakao-map-script");
    if (existingScript) {
      existingScript.remove();
      console.warn("Removed existing Kakao Maps script.");
    }
  }


  loadKakaoMapScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      resolve();
      return;
      // if ((window as any).kakao && (window as any).kakao.maps) {
      //   // console.warn("✅ Kakao Maps script is already loaded.");
      //   resolve();
      //   return;
      // }

      // const existingScript = document.getElementById("kakao-map-script");
      // if (existingScript) {
      //   // console.warn("✅ Kakao Maps script is already in the DOM.");
      //   resolve();
      //   return;
      // }

      // const script = document.createElement("script");
      // script.id = "kakao-map-script";
      // script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=5fc50299fcc0f2142faa37a79e38441f&libraries=services&autoload=false`;
      // script.async = true;

      // script.onload = () => {
      //   if ((window as any).kakao && (window as any).kakao.maps) {
      //     (window as any).kakao.maps.load(() => {
      //       // console.log("✅ Kakao Maps SDK loaded successfully.");
      //       resolve();
      //     });
      //   } else {
      //     reject("❌ Kakao Maps SDK failed to load.");
      //   }
      // };

      // script.onerror = (event) => {
      //   console.error("❌ Failed to load Kakao Maps script:", event);
      //   reject(event);
      // };

      // document.head.appendChild(script);
    });
  }


  resetMap(containerId: string) {
    const container = document.getElementById(containerId);
    if (container) {
      container.innerHTML = "";
      if (containerId == "map-search") {
        container.style.background = 'none';
        container.style.height = '0px';
      }
    }
  }

  initMap(containerId: string, Lat: number, Lng: number, isDrag = false): void {
    this.init(containerId, Lat, Lng)
      .then(map => {
        this.setMarker(Lat, Lng, map, isDrag);
      })
  }

  init(containerId: string, Lat: number, Lng: number): Promise<{ map: any }> {
    return new Promise((resolve, reject) => {
      if (!(window as any).kakao || !(window as any).kakao.maps) {
        reject;
      }

      const container = document.getElementById(containerId);
      if (!container) {
        reject;
      }
      else {
        this.resetMap(containerId)
        if (containerId == "map-search") {
          container.style.height = window.innerWidth < 390 ? '55vh' : '65vh';
        }


        const { width, height } = container?.getBoundingClientRect();
        if (width === 0 || height === 0) {
          reject;
        }

        const options = {
          center: new (window as any)['kakao'].maps.LatLng(Lat, Lng),
          level: containerId == "map-search" ? 1 : 7,
          draggable: true, // Enable dragging on mobileD
          scrollwheel: true, // Enable zooming via touch
          disableDoubleClickZoom: false
        };

        const map = new (window as any).kakao.maps.Map(container, options);
        this.geocoder = new (window as any).kakao.maps.services.Geocoder();
        this.map = map;
        map.addOverlayMapTypeId((window as any).kakao.maps.MapTypeId.TRAFFIC);
        map.addOverlayMapTypeId((window as any).kakao.maps.MapTypeId.TERRAIN);

        var mapTypeControl = new (window as any).kakao.maps.MapTypeControl();
        map.addControl(mapTypeControl, (window as any).kakao.maps.ControlPosition.TOPRIGHT);
        resolve(map);
      }
    })
  }

  setMarker(Lat: any, Lng: any, map: any, isDrag = false) {
    var markerPosition = new (window as any)['kakao'].maps.LatLng(Lat, Lng);

    var marker = new (window as any)['kakao'].maps.Marker({
      position: markerPosition
    });
    marker.setMap(map);

    marker.setDraggable(isDrag)
    if (isDrag) {
      (window as any).kakao.maps.event.addListener(marker, 'dragend', () => {
        const position = marker.getPosition();
        this.getAddress(position.getLat(), position.getLng()).then(p => {
          this.dragMaker.emit(p);
        });
      });
    }
  }

  initMapAndMarkerMuti(containerId: string, Lat: number, Lng: number, data: any) {
    this.init(containerId, Lat, Lng)
      .then(map => {
        this.setMarker(Lat, Lng, map);
        var positions = new Array();
        data.forEach((item: any) => {
          positions.push(
            {
              item,
              title: item.store.storeName,
              latlng: new (window as any)['kakao'].maps.LatLng(item.store.lat, item.store.long)
            })
        })
        var imageSrc = "https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/markerStar.png";
        positions.forEach((element: any) => {
          var imageSize = new (window as any)['kakao'].maps.Size(24, 35);
          var markerImage = new (window as any)['kakao'].maps.MarkerImage(imageSrc, imageSize);
          var marker = new (window as any)['kakao'].maps.Marker({
            map: map,
            position: element.latlng,
            title: element.title,
            image: markerImage
          });

          (window as any).kakao.maps.event.addListener(marker, 'click', () => {
            this.markerClicked.emit(element);
          });
        });
      })
  }

  loadPostcodeScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).daum?.postcode) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      script.onload = () => resolve();
      script.onerror = (error) => reject(error);

      document.head.appendChild(script);
    });
  }

  getLatLng(address: string): Promise<{ lat: number, lng: number }> {
    return new Promise((resolve, reject) => {
      if (!(window as any).kakao || !(window as any).kakao.maps) {
        reject('Kakao Maps SDK chưa được tải.');
        return;
      }

      const geocoder = new (window as any).kakao.maps.services.Geocoder();
      geocoder.addressSearch(address, (result: any[], status: string) => {
        if (status === (window as any).kakao.maps.services.Status.OK) {
          resolve({ lat: parseFloat(result[0].y), lng: parseFloat(result[0].x) });
        } else {
          reject('Không tìm thấy tọa độ.');
        }
      });
    });
  }

  getAddress(lat: number, lng: number): Promise<{ lat: any, long: any, roadAddress: any, buildingName: any }> {
    return new Promise((resolve, reject) => {
      this.geocoder.coord2Address(lng, lat, (result: any, status: any) => {
        if (status === (window as any).kakao.maps.services.Status.OK) {
          const roadAddress = result[0].road_address
            ? result[0].road_address.address_name
            : null;
          const buildingName = result[0].road_address && result[0].road_address.building_name
            ? result[0].road_address.building_name
            : "";
          const ret = {
            lat: lat,
            long: lng,
            roadAddress: roadAddress,
            buildingName: buildingName
          }
          resolve(ret);
        }
        reject();
      });
    })
  }

  resize() {
    const center = this.map.getCenter();
    setTimeout(() => {
      this.map.relayout();
      this.map.setCenter(center);
    }, 300);
  }

  moveToPing(lat: number, lng: number) {
    const newCenter = new (window as any).kakao.maps.LatLng(lat, lng);
    this.map.panTo(newCenter);
  }

  smoothMoveTo(lat: number, lng: number) {
    if (!this.map) return;

    const target = new (window as any).kakao.maps.LatLng(lat, lng);
    const current = this.map.getCenter();

    let start = performance.now();

    const animate = (time: number) => {
      let progress = (time - start) / 500;
      if (progress > 1) progress = 1;

      const interpolatedLat = current.getLat() + (target.getLat() - current.getLat()) * progress;
      const interpolatedLng = current.getLng() + (target.getLng() - current.getLng()) * progress;

      this.map.setCenter(new (window as any).kakao.maps.LatLng(interpolatedLat, interpolatedLng));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }

  trackingEnabled = false;
  watchId: number | null = null;

  toggleTracking() {
    if (this.trackingEnabled) {
      this.stopTracking();
    } else {
      this.startTracking();
    }
  }

  startTracking() {
    if (navigator.geolocation) {
      this.trackingEnabled = true;
      this.watchId = navigator.geolocation.watchPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          this.smoothMoveTo(lat, lng);
        },
        (error) => {
          console.error("Lỗi khi lấy vị trí: ", error);
        },
        { enableHighAccuracy: true, maximumAge: 0, timeout: 5000 }
      );
    } else {
      console.error("Trình duyệt không hỗ trợ GPS.");
    }
  }

  stopTracking() {
    if (this.watchId !== null) {
      navigator.geolocation.clearWatch(this.watchId);
      this.watchId = null;
      this.trackingEnabled = false;
    }
  }

  async drawRoute(startLnglat: any, endLnglat: any) {
    const data = await this.getDirections(startLnglat, endLnglat);

    if (data?.routes?.length > 0) {
      const path = data.routes[0].sections[0].roads.map((road: any) =>
        new (window as any).kakao.maps.LatLng(road.vertexes[1], road.vertexes[0])
      );

      if (this.polyline) {
        this.polyline.setMap(null);
        this.polyline = null;
      }

      this.polyline = new (window as any).kakao.maps.Polyline({
        path: path,
        strokeWeight: 5,
        strokeColor: 'blue',
        strokeOpacity: 0.8,
        strokeStyle: 'solid'
      });

      this.polyline.setMap(this.map);
    } else {
      console.error('Không tìm thấy tuyến đường');
    }
  }

  async getDirections(start: string, end: string): Promise<any> {
    const url = `https://apis-navi.kakaomobility.com/v1/directions?origin=${start}&destination=${end}&priority=RECOMMEND`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `KakaoAK ${this.kakaoApiKey}`
      }
    });

    return response.json();
  }

}
